import { render, staticRenderFns } from "./GuestRelationsVenueBookingOverview.vue?vue&type=template&id=10d42898&scoped=true&"
import script from "./GuestRelationsVenueBookingOverview.vue?vue&type=script&lang=js&"
export * from "./GuestRelationsVenueBookingOverview.vue?vue&type=script&lang=js&"
import style0 from "./GuestRelationsVenueBookingOverview.vue?vue&type=style&index=0&id=10d42898&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d42898",
  null
  
)

export default component.exports